<span class="report-star-link" (click)="highlightedChanged.emit()">
    <capra-icon class="sm-icon"  [ngClass] = "{'star-unfilled' : !highlighted}"  [icon]="highlighted ? 'icon-star-filled' : 'icon-star-unfilled'"></capra-icon>
</span>